/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GeraetDto } from '../models/geraet-dto';
import { getAllGeraete$Json } from '../fn/geraete/get-all-geraete-json';
import { GetAllGeraete$Json$Params } from '../fn/geraete/get-all-geraete-json';
import { getAllGeraete$Plain } from '../fn/geraete/get-all-geraete-plain';
import { GetAllGeraete$Plain$Params } from '../fn/geraete/get-all-geraete-plain';

@Injectable({ providedIn: 'root' })
export class GeraeteApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllGeraete()` */
  static readonly GetAllGeraetePath = '/v1/geraete/all';

  /**
   * Sucht nach Geräten aus der Datenbank der Türen und Zugangsleser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllGeraete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllGeraete$Plain$Response(params?: GetAllGeraete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeraetDto>>> {
    return getAllGeraete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sucht nach Geräten aus der Datenbank der Türen und Zugangsleser.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllGeraete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllGeraete$Plain(params?: GetAllGeraete$Plain$Params, context?: HttpContext): Observable<Array<GeraetDto>> {
    return this.getAllGeraete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GeraetDto>>): Array<GeraetDto> => r.body)
    );
  }

  /**
   * Sucht nach Geräten aus der Datenbank der Türen und Zugangsleser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllGeraete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllGeraete$Json$Response(params?: GetAllGeraete$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeraetDto>>> {
    return getAllGeraete$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sucht nach Geräten aus der Datenbank der Türen und Zugangsleser.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllGeraete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllGeraete$Json(params?: GetAllGeraete$Json$Params, context?: HttpContext): Observable<Array<GeraetDto>> {
    return this.getAllGeraete$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GeraetDto>>): Array<GeraetDto> => r.body)
    );
  }

}
